const DAYS_IN_A_WEEK = 7;
export const SHIPMENT_DELAY_CONTACT_US_THRESHOLD_WEEKS = 8;
export const SHIPMENT_DELAY_CONTACT_US_THRESHOLD_DAYS =
  SHIPMENT_DELAY_CONTACT_US_THRESHOLD_WEEKS * DAYS_IN_A_WEEK;
